module.exports = __webpack_public_path__ + "media/customizations/austinpoint/logo-c6e6c66021fe8440a00528037e2606c3.png";